import { Printable } from "./Printable";
import { Page } from "./Page";

Printable.Page = Page;
export { Printable };
